import type { RoutedActionHandler } from "../../app/actions.ts";

export interface NavigationActionCapabilities {
  closeMenu(): void;
  addSpace(): void | Promise<void>;
  addCollection(rootId: string): void | Promise<void>;
  editSpace(id: string): void | Promise<void>;
  deleteSpace(id: string): void | Promise<void>;
  shareSpace(id: string): void | Promise<void>;
  archiveSpace(id: string): void | Promise<void>;
  transferSpace(id: string): void | Promise<void>;
  spaceDefaults(id: string): void | Promise<void>;
  shareTask(id: string): void | Promise<void>;
  editCollection(id: string): void | Promise<void>;
  duplicateCollection(id: string): void | Promise<void>;
  archiveCollection(id: string): void | Promise<void>;
  shareCollection(id: string): void | Promise<void>;
  deleteCollection(id: string): void | Promise<void>;
  addSubtask(): void;
}

const names = new Set(["add-root", "add-category", "edit-root", "delete-root", "share-root", "archive-root", "transfer-root", "root-task-defaults", "share-task", "edit-category", "duplicate-category", "archive-category", "share-category", "delete-category", "add-subtask"]);

export function createNavigationActionHandler(capabilities: NavigationActionCapabilities): RoutedActionHandler {
  return async (name, target) => {
    if (!names.has(name)) return false;
    const id = target.dataset.id || "";
    if (name === "add-root") await capabilities.addSpace();
    if (name === "add-category") { capabilities.closeMenu(); await capabilities.addCollection(target.dataset.parentRoot || ""); }
    if (name === "edit-root") { capabilities.closeMenu(); await capabilities.editSpace(id); }
    if (name === "delete-root") { capabilities.closeMenu(); await capabilities.deleteSpace(id); }
    if (name === "share-root") { capabilities.closeMenu(); await capabilities.shareSpace(id); }
    if (name === "archive-root") { capabilities.closeMenu(); await capabilities.archiveSpace(id); }
    if (name === "transfer-root") { capabilities.closeMenu(); await capabilities.transferSpace(id); }
    if (name === "root-task-defaults") { capabilities.closeMenu(); await capabilities.spaceDefaults(id); }
    if (name === "share-task") await capabilities.shareTask(id);
    if (name === "edit-category") { capabilities.closeMenu(); await capabilities.editCollection(id); }
    if (name === "duplicate-category") { capabilities.closeMenu(); await capabilities.duplicateCollection(id); }
    if (name === "archive-category") { capabilities.closeMenu(); await capabilities.archiveCollection(id); }
    if (name === "share-category") { capabilities.closeMenu(); await capabilities.shareCollection(id); }
    if (name === "delete-category") { capabilities.closeMenu(); await capabilities.deleteCollection(id); }
    if (name === "add-subtask") capabilities.addSubtask();
    return true;
  };
}
